<template>
  <div class="d-flex flex-wrap">
    <b-badge
      v-for="(value,key) in getValues"
      :key="key"
      pill
      variant="light-secondary"
      class="mb-1"
    >
      {{ value }}
    </b-badge>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import BaseDisplayType from './Base.vue'

export default {
  name: 'MultipicklistDisplayType',
  components: {
    BBadge,
  },
  extends: BaseDisplayType,
  computed: {
    getValues() {
      return this.data.value ? this.data.value.split(',') : []
    },
  },
}
</script>

<style scoped>

</style>
